import HelloWidget from './components/HelloWidget'

export const components = {
  HelloWidget,
}
